const CACHE_PREFIX = 'vivosol:bess-if:v1:';

export function isolationForestCacheKey(portfolioName, startDate, endDate) {
  return `${CACHE_PREFIX}${portfolioName}:${startDate}:${endDate}`;
}

export function readIsolationForestCache(portfolioName, startDate, endDate) {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(
      isolationForestCacheKey(portfolioName, startDate, endDate),
    );
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.bySeries || typeof parsed.bySeries !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeIsolationForestCache(portfolioName, startDate, endDate, payload) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  if (!payload?.bySeries) return;
  try {
    const toStore = {
      portfolioName,
      startDate,
      endDate,
      source: payload.source,
      fields: payload.fields,
      contamination: payload.contamination,
      bySeries: payload.bySeries,
      cachedAt: new Date().toISOString(),
    };
    window.localStorage.setItem(
      isolationForestCacheKey(portfolioName, startDate, endDate),
      JSON.stringify(toStore),
    );
  } catch {
    // Quota / private mode — ignore; in-memory state still works.
  }
}

export function sliceIsolationForestSeries(cachedPayload, series) {
  const key = String(series || 'ALL').toUpperCase();
  const slice = cachedPayload?.bySeries?.[key] || cachedPayload?.bySeries?.ALL || null;
  if (!slice) {
    return {
      series: key,
      startDate: cachedPayload?.startDate,
      endDate: cachedPayload?.endDate,
      source: cachedPayload?.source,
      deviceCount: 0,
      anomalyCount: 0,
      watchlist: [],
      emptyMessage: `No cached analysis for series ${key}.`,
    };
  }
  return {
    series: key,
    startDate: cachedPayload?.startDate,
    endDate: cachedPayload?.endDate,
    source: cachedPayload?.source,
    fields: cachedPayload?.fields,
    contamination: slice.contamination ?? cachedPayload?.contamination,
    deviceCount: slice.deviceCount ?? 0,
    anomalyCount: slice.anomalyCount ?? 0,
    watchlist: slice.watchlist ?? [],
    emptyMessage: slice.emptyMessage ?? null,
  };
}
